import DocumentIcon from '../icon/DocumentIcon';
import ExcelIcon from '../icon/ExcelIcon';
import MediaIcon from '../icon/MediaIcon';
import PdfIcon from '../icon/PdfIcon';
import PowerPointIcon from '../icon/PowerPointIcon';
import WordIcon from '../icon/WordIcon';

export default function getIconFile(filename: string, size?: 'small') {
  const lastDotIndex = filename.lastIndexOf('.');
  const fileType = filename.substring(lastDotIndex);

  switch (fileType) {
    case '.doc':
    case '.docx':
      return <WordIcon fontSize={size} />;
    case '.ppt':
    case '.pptx':
      return <PowerPointIcon fontSize={size} />;
    case '.xls':
    case '.xlsx':
      return <ExcelIcon fontSize={size} />;
    case '.pdf':
      return <PdfIcon fontSize={size} />;
    case '.png':
    case '.jpg':
    case '.jpeg':
    case '.gif':
      return <MediaIcon fontSize={size} />;
    default:
      return <DocumentIcon fontSize={size} />;
  }
}
